// extracted by css-extract-rspack-plugin
export default {"Flex":"CursorPagination_Flex__Kfxgm","Wrapper":"CursorPagination_Wrapper__Ewf1L","Results":"CursorPagination_Results__KleoL"};